import React from "react";

const SocialLinks = ({data}) => {

    return (<>
        
        {data.twitter_link && 
        <a href={data.twitter_link} target={"_blank"} aria-label="twitter">
            <i className="icon-twitter"></i>
        </a>
        }

        {data.facebook_link && 
        <a href={data.facebook_link} target={"_blank"} aria-label="facebook">
            <i className="icon-fb"></i>
        </a>
        }

        {data.instagram_link && 
        <a href={data.instagram_link} target={"_blank"} aria-label="instagram">
            <i className="icon-insta"></i>
        </a>
        }

        {data.youtube_link && 
            <a href={data.youtube_link} target={"_blank"} aria-label="youtube">
                <i className="icon-youtube"></i>
            </a>
        }

        {data.linkedin_link && 
            <a href={data.linkedin_link} target={"_blank"} aria-label="linkedin">
                <i className="icon-linkedin"></i>
            </a>
        }

        {data.pinterest_link && 
            <a href={data.pinterest_link} target={"_blank"} aria-label="pinterest">
                <i className="icon-pinterest"></i>
            </a>
        }
    </>)
}
export default SocialLinks;